import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ShowroomsSharedModule } from "../features/showrooms/shared/showrooms-shared.module";
import { ProtectedModule } from "../protected/protected.module";
import { PublicModule } from "../public/public.module";
import { SharedModule } from "../shared/shared.module";
import { ContentComponent } from "./content/content.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { InitialLoadComponent } from "./initial-load/initial-load.component";

@NgModule({
  declarations: [FooterComponent, HeaderComponent, ContentComponent, InitialLoadComponent],
  imports: [SharedModule, PublicModule, ProtectedModule, ShowroomsSharedModule, RouterModule],
  exports: [FooterComponent, HeaderComponent, ContentComponent, InitialLoadComponent],
})
export class LayoutModule {}
